module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chap-title1"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc-head"
  }, [_c('a', {
    attrs: {
      "href": "#/Introduction"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1"
    }
  }, [_vm._v("USING FUSE BEADS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-1"
    }
  }, [_vm._v("Buying beads")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-2"
    }
  }, [_vm._v("Equipment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-3"
    }
  }, [_vm._v("Creating a design")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-4"
    }
  }, [_vm._v("Ironing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-5"
    }
  }, [_vm._v("Ironing choices")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MATERIALS AND EQUIPMENT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BASIC TECHNIQUES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Using jump rings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bending")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peyote stitch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reading a peyote stitch chart")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Joing peyote bands")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DESIGNS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', {
    attrs: {
      "href": "#/Acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', {
    attrs: {
      "href": "#/Suppliers",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Suppliers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', {
    attrs: {
      "href": "#/Author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbd272c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 63
// module chunks = 0